module.exports = __webpack_public_path__ + "static/media/practica02092020.f1a4267a.r";